import { X } from "lucide-react";
import { useFormatAmount } from "../../hooks/useFormatAmount";

const DisburseDetails = ({
  closeDisburseDetails,
  handleChooseDisburseType,
  loanApplication,
  handleDeclineDisburse,
}) => {
  const formatAmount = useFormatAmount();
  return (
    <div
      onClick={(e) => {
        closeDisburseDetails();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[580px] rounded-[10px] py-[20px] px-[40px] relative bg-white"
      >
        <div
          onClick={closeDisburseDetails}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div>
          <p className="text-[#000000] font-semibold text-[18px]">
            Loan Details
          </p>
          <p className="text-[#5C5C5C] text-[14px] font-normal">
            Review loan details
          </p>
          <div>
            <div className="flex items-center justify-between my-[20px] border-b-[1px] border-[#A8A8A8]">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Borrower’s Name
              </p>
              <p className="text-[#000000] text-[16px] font-medium">
                {loanApplication?.customer?.firstname}{" "}
                {loanApplication?.customer?.middlename}{" "}
                {loanApplication?.customer?.lastname}
              </p>
            </div>
            <div className="flex items-center justify-between my-[20px] border-b-[1px] border-[#A8A8A8]">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Loan Product
              </p>
              <p className="text-[#000000] text-[16px] font-medium">
                {loanApplication?.product?.name}
              </p>
            </div>
            <div className="flex items-center justify-between my-[20px] border-b-[1px] border-[#A8A8A8]">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Loan Principal
              </p>
              <p className="text-[#000000] text-[16px] font-medium">
                {formatAmount(loanApplication?.loanAmount)}
              </p>
            </div>
            <div className="flex items-center justify-between my-[20px] border-b-[1px] border-[#A8A8A8]">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Interest Rate
              </p>
              <p className="text-[#000000] text-[16px] font-medium">
                {loanApplication?.interestRate ?? 0}%
              </p>
            </div>
            <div className="flex items-center justify-between my-[20px] border-b-[1px] border-[#A8A8A8]">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Repayment Amount
              </p>
              <p className="text-[#000000] text-[16px] font-medium">
                {formatAmount(loanApplication?.repaymentAmount ?? 0)}
              </p>
            </div>
            <div className="flex items-center justify-between my-[20px] border-b-[1px] border-[#A8A8A8]">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Excise Duty
              </p>
              <p className="text-[#000000] text-[16px] font-medium">
                {formatAmount(0)}
              </p>
            </div>
            <div className="flex items-center justify-between my-[20px] border-b-[1px] border-[#A8A8A8]">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Total Repayment Amount
              </p>
              <p className="text-[#000000] text-[16px] font-medium">
                {formatAmount(loanApplication?.repaymentAmount ?? 0)}
              </p>
            </div>
            <div className="flex items-center justify-between my-[20px] border-b-[1px] border-[#A8A8A8]">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Monthly Repayment
              </p>
              <p className="text-[#000000] text-[16px] font-medium">
                {formatAmount(0)}
              </p>
            </div>
            <div className="flex items-center justify-between my-[20px] border-b-[1px] border-[#A8A8A8]">
              <p className="text-[#5C5C5C] text-[16px] font-normal">Maturity</p>
              <p className="text-[#000000] text-[16px] font-medium">None</p>
            </div>
            <div className="flex items-center mt-[40px] justify-between w-full">
              <button
                onClick={handleDeclineDisburse}
                className="h-[35px] bg-[#FFDEDE] rounded-[30px] px-[15px] text-[#222222] font-medium"
              >
                Decline Disbursement
              </button>
              <div className="flex items-center justify-center gap-[10px]">
                <button
                  onClick={closeDisburseDetails}
                  className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={handleChooseDisburseType}
                  className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
                >
                  Disburse Loan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisburseDetails;
